import { Spinner } from '@ui/components';
import React, { FC, Suspense } from 'react';

interface MainSuspenseProps {
  children: React.ReactNode;
}

export const MainSuspense: FC<MainSuspenseProps> = (props) => {
  const { children } = props;
  return (
    <div className="h-screen w-screen">
      <Suspense
        fallback={
          <div className="flex size-full items-center justify-center">
            <Spinner className="size-12" />
          </div>
        }
      >
        {children}
      </Suspense>
    </div>
  );
};
